import { render, staticRenderFns } from "./create-logisticscost.vue?vue&type=template&id=6143c16b"
import script from "./create-logisticscost.vue?vue&type=script&lang=ts"
export * from "./create-logisticscost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports